// ═══════════════════════════════════════════════════════════════════
//  modules/courriel/utils.js
//  mailHeaders · mailDate · telechargerPJ · btnStyle · filtreStyle
// ═══════════════════════════════════════════════════════════════════

import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";

export function mailHeaders(token) {
  return { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
}

export function mailDate(iso, court) {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  if (court) {
    const memeJour = d.toDateString() === new Date().toDateString();
    return memeJour
      ? d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })
      : d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit" });
  }
  return d.toLocaleString("fr-FR", { dateStyle: "long", timeStyle: "short" });
}

export async function telechargerPJ(token, uid, a, dossier) {
  try {
    const res = await fetch(`${API_BASE}/api/mail/message/${uid}/attachment/${a.index}?folder=${dossier || "inbox"}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return;
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const lien = document.createElement("a");
    lien.href = url; lien.download = a.filename || "piece_jointe";
    document.body.appendChild(lien); lien.click(); lien.remove();
    URL.revokeObjectURL(url);
  } catch { /* silencieux */ }
}

export function btnStyle(primaire) {
  return {
    background: primaire ? THEME.accent : THEME.panel,
    border: `1px solid ${primaire ? THEME.accent : THEME.border}`,
    color: primaire ? "#fff" : THEME.text,
    borderRadius: 8, padding: "6px 13px", fontSize: 12.5, fontWeight: 600,
    cursor: "pointer", fontFamily: "inherit",
  };
}

export function filtreStyle(actif, t) {
  return {
    background: actif ? (t ? t.bg : THEME.accentDim) : THEME.surface,
    border: `1px solid ${actif ? (t ? t.color : THEME.accent) : THEME.border}`,
    color: actif ? (t ? t.color : "#9CC2FF") : THEME.textMuted,
    borderRadius: 999, padding: "5px 12px", fontSize: 12, fontWeight: 700,
    cursor: "pointer", fontFamily: "inherit",
  };
}
